import home from "./home";
import carta from "./carta";
import updateZclousure from "./updateZclousure";
import UpdatePaymentNumber from "./updatePaymentNumber";
import terms from "./terms";
import privacy from "./privacy";
import recoverPassword from "./recoverPassword";
import cookies from "./cookies";
import successApplepay from "./successApplepay";
import successRedsys from "./successRedsys";
import successBizum from "./successBizum";
import successGooglepay from "./successGooglepay";
import success from "./success";
import receipt from "./receipt";
import recent from "./recent";

export default [
  {
    ...home
  },
  {
    ...carta
  },
  {
    ...updateZclousure
  },
  {
    ...UpdatePaymentNumber
  },
  {
    ...terms
  },
  {
    ...privacy
  },
  {
    ...recoverPassword
  },
  {
    ...cookies
  },
  {
    ...successApplepay
  },
  {
    ...successRedsys
  },
  {
    ...successBizum
  },
  {
    ...successGooglepay
  },
  {
    ...success
  },
  {
    ...receipt
  },
  {
    ...recent
  }
];
